import { type SmsAreaCode } from '../../../../models/Scheduling'

export const areaCodeLocation = ({ city, state, stateName }: SmsAreaCode): string => (city != null ? `${city}, ${state}` : stateName)
